
import AxiosApiClient from './AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';

// helper for API backend selection
const getAuthApi = () => {
    return localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== ''
        ? localStorage.getItem('auth_api')
        : 'phpLaravel';
};

export const LogoutService = ({ setIsLoading, navHistory, swal }) => {

    setIsLoading(true);

    const fetchApiDataLogout = async () => {
        try {
            const { getBearerToken, makeRequestWithHeaders } = AxiosApiClient({
                apiBackend: getAuthApi(),
                token: localStorage.getItem('auth_token'),
            });

            await getBearerToken();
            const response = await makeRequestWithHeaders('get', '/api/logout', null, {});

            setApiDataLogout(response, "LogoutService", { setIsLoading, navHistory, swal });
        } catch (error) {
            handleApiErrorLogout(error, "LogoutService", { setIsLoading, navHistory, swal });
        }
    };

    fetchApiDataLogout();
};

function setApiDataLogout(response, theFunction, { setIsLoading, navHistory, swal }) {
    if (response && response.data) {
        if (response.data.status === 200) {
            console.log(theFunction + ': ', response.data.message);

            AuthUtility.clearAuthData();
            AuthUtility.clearOrganizationData();
            navHistory('/');
        } else if (response.data.status === 401) {
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            AuthUtility.clearAuthData();
            AuthUtility.clearOrganizationData();
            swal("Warning", response.data.message, "warning");
            navHistory('/login');
        } else {
            console.warn(theFunction + ' error: unexpected status', response.data);
        }
    }

    setIsLoading(false);
}

function handleApiErrorLogout(error, theFunction, { setIsLoading, navHistory, swal }) {
    console.log(theFunction + ' error: ', error + ' back-end api call error');

    AuthUtility.clearAuthData();
    AuthUtility.clearOrganizationData();
    setIsLoading(false);
    swal("Error", error.toString(), "error");
    navHistory('/login');
}